import { useQuery } from '@tanstack/react-query';

import { createNotificationsQuery } from '@feat/notifications/utilities/create-notifications-query';
import { useApplicationStore } from '@hooks/application/application-store.hook';

export const useGetNotifications = () => {
  const enterpriseApi = useApplicationStore(({ enterpriseApi }) => {
    return enterpriseApi;
  });

  return useQuery(createNotificationsQuery(enterpriseApi));
};
